// extracted by mini-css-extract-plugin
export default {"result":"style_result__W4X7C"};